const styles = `:host(.more-items-popover[state=collapsed]){width:calc(100% - 16px)}`;export default styles;